import { render, staticRenderFns } from "./PayFund.vue?vue&type=template&id=2dabd872&scoped=true"
import script from "./PayFund.vue?vue&type=script&lang=js"
export * from "./PayFund.vue?vue&type=script&lang=js"
import style0 from "./PayFund.vue?vue&type=style&index=0&id=2dabd872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dabd872",
  null
  
)

export default component.exports